import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { BancoService } from 'src/app/services/banco.service';
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'

export interface IDepositoAgregado {
  banco: number | string,
  nombreBanco: string,
  cuenta: number | string,
  nroDeposito: number | string,
  fechaDeposito: Date | string,
  tipo_cuenta_bancaria_codigo: number
}
@Component({
  selector: 'app-destino-deposito-modal-agregar-banco',
  templateUrl: './modal-agregar-banco.component.html',
  styleUrls: ['../destino-deposito.component.scss'],
  providers: [SecurityService],
})
export class DestinoDepositoModalAgregarBancoComponent implements OnInit {

  // Modales
  @ViewChild('agregarBanco', { static: true }) modalAgregarBanco: ModalDirective;
  @ViewChild('datePickerFechaDeposito', { static: true }) datePickerFechaDeposito: MDBDatePickerComponent

  @Output() onSuccess: EventEmitter<IDepositoAgregado> = new EventEmitter<IDepositoAgregado>()

  // Form
  formHeader: FormGroup

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;


  optionsBanco: Array<any> = [];
  optionsCuenta: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private bancoService: BancoService,
    private datesService: DatesService,
    private cuentaBancariaService: CuentaBancariaService,
  ) {
    this.log = this.clog.log('DESTINO-DEPOSITO/MODAL-AGREGAR-BANCO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.getBancos()

    this.createForm()
    this.formChangesSubscriptions()
  }

  private getBancos() {
    this.bancoService.obtenerBancoEmpresas(
      this.rutEmpresa,
      true,
      ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.optionsBanco = registros.map(banco => ({ value: banco.codigo, label: banco.nombre, ...banco }))
      }
    )
  }

  private createForm() {
    this.formHeader = this.fb.group({
      banco: [null, [Validators.required]],
      cuenta: [null, [Validators.required]],
      nroDeposito: [null, [Validators.required]],
      fechaDeposito: [null, [Validators.required]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("banco").valueChanges.subscribe(banco_codigo => {
      this.getCuentas(banco_codigo)
    })
  }

  getCuentas(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(
      this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.formHeader.get('cuenta').setValue(null)
        this.formHeader.get('cuenta').markAsPristine()
        this.formHeader.get('cuenta').markAsUntouched()
        this.optionsCuenta = registros.map(cuenta => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }))
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('cuenta'), this.optionsCuenta)
      })
  }

  show() {
    this.reset()
    this.setInitialValues()
    this.modalAgregarBanco.show()
  }

  reset() {
    this.formValidatorsService.reset(this.formHeader)
  }

  setInitialValues() {
    this.datePickerFechaDeposito.clearDate()
    const now = this.datesService.CurrentDateToShortTimeString()
    this.formHeader.get('fechaDeposito').setValue(now)
  }

  agregar() {
    const valid = this.formValidatorsService.validate(this.formHeader)
    if (!valid) {
      return
    }

    // nombre banco
    const arrayNombreBanco = this.optionsBanco.filter(p => p.value === this.formHeader.get('banco').value)
    const nombreBanco = (arrayNombreBanco && arrayNombreBanco.length > 0) ? arrayNombreBanco[0].nombre : ''

    // tipo_cuenta_bancaria_codigo
    const arrayCuentaSeleccionada = this.optionsCuenta.filter(p => p.value === this.formHeader.get('cuenta').value)
    const tipo_cuenta_bancaria_codigo = (arrayCuentaSeleccionada && arrayCuentaSeleccionada.length > 0) ? arrayCuentaSeleccionada[0].tipo_cuenta_bancaria_codigo : 0

    const payload: IDepositoAgregado = {
      ...(_.cloneDeep(this.formHeader.value)),
      nombreBanco,
      tipo_cuenta_bancaria_codigo
    }
    this.onSuccess.emit(payload)
    this.modalAgregarBanco.hide()
  }

}
